import React, { FC } from 'react';

import { Illustration, IllustrationProps } from '../IllustrationWrapper';

export const DetachedHouse: FC<IllustrationProps> = ({ size, color }) => (
  <Illustration size={size} color={color}>
    <path d="M66 70H14C11.79 70 10 68.21 10 66V35.56C10 33.71 10.83 31.99 12.29 30.85L37.6 10.91C39.06 9.75999 41.1 9.75999 42.56 10.91L67.73 30.84C69.18 31.98 70.01 33.7 70.01 35.54V65.99C70.01 68.2 68.22 69.99 66.01 69.99L66 70ZM40.07 14.05L14.76 33.98C14.28 34.36 14 34.93 14 35.55V65.99H66V35.54C66 34.93 65.72 34.35 65.24 33.97L40.07 14.05Z" />
  </Illustration>
);
